import { Component, Input, ElementRef, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

declare var bootstrap: any;

@Component({
    standalone: true,
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    imports: [CommonModule],
})
export class ToastComponent {
    private toast_instance: any;
    public icon: string = '';
    public color_class: string = '';

    @Input() time: string = 'Now';
    @Input() toast_classes: any = '';
    @Input() title: string = 'Notification';
    @Input() message: string = 'Notification message';
    @Input() type: 'success' | 'error' | 'warning' | 'info' = 'success';
    @Input() animation: 'fade' | 'slide' | 'slide-fade' = 'slide-fade';
    @Input() position: 'top-right' | 'top-left' | 'top-center' | 'bottom-right' | 'bottom-left' | 'bottom-center' = 'top-right';
    @Input() url: string | null = null;
    @Input() url_target: string = '_self';
    @Input() url_query: any = null;

    @Input() onClick: (() => void) | null = null;

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef,
        private Router: Router,
    ) {

    }

    show() {
        setTimeout(() => {
            const toast_el: HTMLElement | null = this.elementRef.nativeElement.querySelector('.toast');

            if (!toast_el) {
                console.error('[ToastComponent] .toast element not found');
                return;
            }

            this.mapTypeToStyle();
            this.mapTypeToClasses();
            this.mapAnimationToStyle(toast_el);
            this.mapPositionToStyle(toast_el);
            this.applyStacking(this.position);

            if (this.url || this.onClick) {
                this.renderer.setStyle(toast_el, 'cursor', 'pointer');
            }

            // if (this.url || this.onClick) {
            //     this.renderer.setStyle(toast_el, 'cursor', 'pointer');

            //     toast_el.addEventListener('click', () => {
            //         this.handleClick();
            //     });
            // }

            try {
                this.toast_instance = new bootstrap.Toast(toast_el, { delay: 4000 });
                this.toast_instance.show();
            }

            catch (error) {
                console.error('Bootstrap Toast init error:', error);
            }
        }, 5);
    }

    handleClick(): void {
        if (this.onClick && typeof this.onClick === 'function') {
            this.onClick();
        }

        if (!this.url) {
            return;
        }

        const url = this.url.trim();
        
        if (url.startsWith('http://') || url.startsWith('https://')) {
            if (this.url_target === '_blank') {
                window.open(url, '_blank');
                return;
            }

            window.location.href = url;
            return;
        }

        if (url.startsWith('/')) {
            this.Router.navigateByUrl(url);
            return;
        }

        this.Router.navigate([url], {
            queryParams: this.url_query ?? {}
        });
    }

    private mapTypeToStyle() {
        const map: any = {
            success: { icon: 'ni ni-check-bold', color: 'text-success' },
            error: { icon: 'ni ni-fat-remove', color: 'text-danger' },
            warning: { icon: 'ni ni-fat-add', color: 'text-warning' },
            info: { icon: 'ni ni-single-copy-04', color: 'text-info' },
            'ios-ultra': 'toast-glass-ios-ultra',
        };

        const selected = map[this.type] ?? map['info'];

        this.icon = selected.icon;
        this.color_class = selected.color;
    }

    private mapTypeToClasses() {
        this.toast_classes = [
            'toast-glass',
        ].join(' ');
    }

    private mapAnimationToStyle(toast_el: HTMLElement) {
        const map: Record<string, string> = {
            'fade': 'toast-fade',
            'slide': 'toast-slide',
            'slide-fade': 'toast-slide-fade'
        };

        const animation_class = map[this.animation] ?? 'toast-slide-fade';

        this.renderer.addClass(toast_el, animation_class);
    }

    private mapPositionToStyle(toast_el: HTMLElement) {
        const map: Record<string, string> = {
            'top-right': 'toast-top-right',
            'top-left': 'toast-top-left',
            'top-center': 'toast-top-center',
            'bottom-right': 'toast-bottom-right',
            'bottom-left': 'toast-bottom-left',
            'bottom-center': 'toast-bottom-center'
        };

        const position_class = map[this.position] ?? 'top-right';

        this.renderer.addClass(toast_el, position_class);
    }

    private applyStacking(position: string) {
        const host = this.elementRef.nativeElement;

        this.renderer.removeClass(host, 'toast-stack-top');
        this.renderer.removeClass(host, 'toast-stack-bottom');
        this.renderer.removeClass(host, 'toast-stack-left');
        this.renderer.removeClass(host, 'toast-stack-right');
        this.renderer.removeClass(host, 'toast-stack-center');

        switch (position) {
            case 'top-right':
            case 'top-left':
            case 'top-center':
                this.renderer.addClass(host, 'toast-stack-top');
                break;

            case 'bottom-right':
            case 'bottom-left':
            case 'bottom-center':
                this.renderer.addClass(host, 'toast-stack-bottom');
                break;
        }

        if (position.includes('left')) {
            this.renderer.addClass(host, 'toast-stack-left');
        }

        if (position.includes('right')) {
            this.renderer.addClass(host, 'toast-stack-right');
        }

        if (position.includes('center')) {
            this.renderer.addClass(host, 'toast-stack-center');
        }
    }
}